import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

import { MiniModalLoadingContent } from './MiniModalLoadingContent';

const styles = cssMap({
	wrapper: {
		boxSizing: 'border-box',
		width: '100%',
		height: 'auto',
		backgroundColor: token('elevation.surface'),
		display: 'flex',
		flexDirection: 'column',
		alignContent: 'stretch',
		alignItems: 'stretch',
		borderRadius: token('radius.xxlarge'),
		boxShadow: token('elevation.shadow.overlay'),
		overflow: 'hidden',
	},
	wrapperNav3: {
		marginTop: token('space.200'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderTopLeftRadius: token('radius.large'),
		borderTopRightRadius: token('radius.large'),
	},
});

// This shell loads before the assistant providers. Keep it independent of MainWrapper so
// the async entry point does not eagerly load the chat layout and session panels.
export const MiniModalLoadingFallback = ({
	topOffset,
	isNav4Enabled,
}: {
	topOffset: number;
	isNav4Enabled: boolean;
}): JSX.Element => (
	<Box
		data-rovo-chat-panel="true"
		xcss={cx(styles.wrapper, !isNav4Enabled && styles.wrapperNav3)}
		style={{ width: isNav4Enabled ? undefined : `calc(100% - ${token('space.150')})` }}
	>
		<MiniModalLoadingContent topOffset={topOffset} />
	</Box>
);
